export default window.jQuery || window.Zepto;
